<template>
    <div>
        <ul v-if="hasALink()">
            <li v-if="fields['first-url'].value">
                <a :href="fields['first-url'].value" :target="buildLinkTarget(fields['first-new-tab'])">
                    {{ fields['first-text'].value }}
                </a>
            </li>

            <li v-if="fields['second-url'].value">
                <a :href="fields['second-url'].value" :target="buildLinkTarget(fields['second-new-tab'])">
                    {{ fields['second-text'].value }}
                </a>
            </li>

            <li v-if="fields['third-url'].value">
                <a :href="fields['third-url'].value" :target="buildLinkTarget(fields['third-new-tab'])">
                    {{ fields['third-text'].value }}
                </a>
            </li>

            <li v-if="fields['fourth-url'].value">
                <a :href="fields['fourth-url'].value" :target="buildLinkTarget(fields['fourth-new-tab'])">
                    {{ fields['fourth-text'].value }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            fields: Object,
        },

        methods: {
            hasALink() {
                return this.fields['first-url'].value
                    || this.fields['second-url'].value
                    || this.fields['third-url'].value
                    || this.fields['fourth-url'].value;
            },

            buildLinkTarget(linkNewTab) {
                return linkNewTab.value === 'on' ? '_blank' : null;
            }
        }
    }
</script>
